<template>
  <div>
    <div class="table-responsive">
      <table class="table table-active rounded mt-5 text-center">
        <thead>
        <tr>
          <th>شماره سبد</th>
          <th scope="col">مقدار پرداختی</th>
          <th scope="col">وضعیت پرداخت</th>
          <th scope="col">شماره تراکنش</th>
          <th scope="col">توکن پرداخت</th>
        </tr>
        </thead>
        <tbody>
        <tr>
          <td>{{ transactionData.order_id }}</td>
          <td>{{ formatNumber(transactionData.amount) }}</td>
          <td>{{ transactionData.status }}</td>
          <td>{{ transactionData.trans_id }}</td>
          <td>{{ transactionData.token }}</td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import {formatNumber} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";

export default {
  name: "transactionTable",
  props: ["item"],
  data() {
    return {};
  },
  computed: {
    transactionData() {
      return this.item
    },
  },
  methods: {
    formatNumber,

  },
};
</script>